import { render, staticRenderFns } from "./TaxReturnRif.vue?vue&type=template&id=89ce052c&scoped=true"
import script from "./TaxReturnRif.vue?vue&type=script&lang=js"
export * from "./TaxReturnRif.vue?vue&type=script&lang=js"
import style0 from "./TaxReturnRif.vue?vue&type=style&index=0&id=89ce052c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ce052c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89ce052c')) {
      api.createRecord('89ce052c', component.options)
    } else {
      api.reload('89ce052c', component.options)
    }
    module.hot.accept("./TaxReturnRif.vue?vue&type=template&id=89ce052c&scoped=true", function () {
      api.rerender('89ce052c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/TaxReturnRif.vue"
export default component.exports